import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';
import { getAuthToken } from './authTokenProvider';
import {
  REACT_APP_BASE_URL,
  REACT_APP_BASE_URL_TAKEDOWN,
  REACT_APP_FEED_API_BASE_URL,
} from '../utils/envVar';

const BASE_URL = REACT_APP_BASE_URL;
const BASE_URL_TAKEDOWN = REACT_APP_BASE_URL_TAKEDOWN;
const FEED_API_BASE_URL = REACT_APP_FEED_API_BASE_URL;

export const getToken = () => {
  return window.localStorage.getItem('userToken');
};

export const apiClient = async ({
  url,
  headers,
  ...config
}: AxiosRequestConfig): Promise<AxiosPromise<any>> => {
  const token = await getAuthToken();
  try {
    const res = await axios({
      url: `${BASE_URL}/${url}`,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      ...config,
    });
    return res;
  } catch (error: any) {
    throw error;
  }
};

export const apiClientTakeDown = async ({
  url,
  headers,
  ...config
}: AxiosRequestConfig): Promise<AxiosPromise<any>> => {
  const token = await getAuthToken();
  try {
    const res = await axios({
      url: `${BASE_URL_TAKEDOWN}/${url}`,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      ...config,
    });
    return res;
  } catch (error: any) {
    throw error;
  }
};

export const apiClientFeed = async ({
  url,
  headers,
  ...config
}: AxiosRequestConfig): Promise<AxiosPromise<any>> => {
  const token = await getAuthToken();
  try {
    const res = await axios({
      url: `${FEED_API_BASE_URL}/${url}`,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
        Authorization: `Bearer ${token}`,
        'X-Authorization': token,
      },
      ...config,
    });
    return res;
  } catch (error: any) {
    throw error;
  }
};
